<template>
  <div class="row mt-2 mb-2 justify-content-md-center justfiy-content-left">
    <div class="col-sm-9 col-lg-10 pr-sm-0">
      <submission-card
        :id="id"
        :text="text"
        :status="status"
        :image_url="image_url"
        :submission_time="submission_time"
        :filter_phrases="filter_phrases"
        :route_truth_details="route_truth_details"
        :header_text="header_text"
        :numbered="numbered"
        :nsfw_probability="nsfw_probability"
      ></submission-card>
    </div>

    <div class="col-sm-3 col-md-2 px-3">
      <sub-buttons
        :id="id"
        :text="text"
        :image_url="image_url"
        :secondary-pages="secondaryPages"
        :route_truth_details="route_truth_details"
        :instagram="instagram"
        v-on="$listeners"
      ></sub-buttons>
    </div>
  </div>
</template>

<script>
import SubmissionCard from "../submissions/SubmissionCard";
import SubButtons from "./SubButtons";

export default {
  name: "SortingListItem",

  components: {
    SubmissionCard,
    SubButtons
  },

  props: {
    id: {
        type: Number,
        required: true,
    },
    text: {
        type: String,
        required: true,
    },
    status: {
        type: String,
        required: true,
    },
    image_url: {
        type: String,
    },
    submission_time: {
        type: String,
        required: true,
    },
    filter_phrases: {
        type: Array,
        default: () => [],
    },
    route_truth_details: {
        type: String,
        required: true,
    },
    secondaryPages: {
        type: Array,
        default: () => []
    },
    header_text: {
        type: String
    },
    numbered: {
        type: Boolean,
        required: true
    },
    nsfw_probability: {
        type: Number
    },
    instagram: {
      type: Boolean,
      default: null
    }
  }
};
</script>